import { ComponentStyleConfig } from '@chakra-ui/react';

export const Checkbox: ComponentStyleConfig = {
  baseStyle: {
    icon: {
      color: 'dynamic.highlight',
    },
    control: {
      border: '1px',
      borderColor: 'gray.50',
      borderRadius: 'sm',
      _hover: { borderColor: 'gray.100' },
      _checked: {
        bg: 'white',
        borderColor: 'gray.50',
        _hover: { bg: 'white', borderColor: 'gray.100' },
      },
      _disabled: {
        borderColor: 'gray.300',
        bg: 'gray.200',
      },
    },
  },
  variants: {
    accent: {
      icon: {
        color: 'dynamic.accent',
      },
    },
  },
};
